export { default as modalMixin } from './modal.mixins';